import React, { useEffect, useState } from 'react';

import MFormCardView from './MFormCard.view';

type Props = {
  className?: string;
  header?: string | JSX.Element;
  bodyClassName?: string;
  headerClassName?: string;
  showToggler?: boolean;
  isFullScreen?: boolean;
  isSectionSubmitted?: boolean;
};

const MFormCard: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const [showState, setShowState] = useState<boolean>(() => (props.isSectionSubmitted !== undefined ? false : true));

  useEffect(() => {
    if (props.isSectionSubmitted) {
      setShowState(() => false);
    }
  }, [props.isSectionSubmitted, setShowState]);

  return (
    <MFormCardView
      className={props.className}
      onToggleClick={() => setShowState((prev: boolean) => !prev)}
      showToggler={props.showToggler}
      showBody={showState}
      header={props.header}
      headerClassName={props.headerClassName}
      isFullScreen={props.isFullScreen}
      bodyClassName={props.bodyClassName}
      isSectionSubmitted={props.isSectionSubmitted}
    >
      {props.children}
    </MFormCardView>
  );
};

MFormCard.displayName = 'MFormCard';
MFormCard.defaultProps = {};

export default MFormCard;
